import React, { useState } from 'react';

const useDialog = () => {
	const [openDialog, setOpenDialog] = useState(false);

	const handleDialogOpen = () => {
		setOpenDialog(true);
	};

	const handleDialogClose = () => {
		setOpenDialog(false);
	};
	return {
		openDialog,
		handleDialogOpen,
		handleDialogClose,
	};
};

export default useDialog;
